import { BacktestType } from "@/features/backtest"

export const purchaseTypeMap: Record<BacktestType.PurchaseType, string> = {
  num_shares: "Number of shares",
  portfolio_weights: "Portfolio Weights (%)",
  max_out: "Max out (%)"
}
